export default {
  empty_list: 'Sem categorias ainda',
  uses_restaurant_open_times: 'Usa os horários de abertura do restaurante',
  products_creation_disabled:
    'Devido à integração ativa com {{integration}}, não é permitida a criação de novos produtos. Se precisar de alterar o menu, faça as alterações em {{integration}} e sincronize o menu.',
  buttons: {
    add_category: 'Adicionar categoria',
  },
  toasts: {
    something_went_wrong: 'Algo correu mal',
  },
};
